import { render, staticRenderFns } from "./insuranceReview.vue?vue&type=template&id=28db8184&scoped=true&"
import script from "./insuranceReview.vue?vue&type=script&lang=js&"
export * from "./insuranceReview.vue?vue&type=script&lang=js&"
import style0 from "./insuranceReview.vue?vue&type=style&index=0&id=28db8184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db8184",
  null
  
)

export default component.exports